<template>
  <two-factor-layout
    v-if="challenge"
    title="Protege tu cuenta"
    subtitle="Para entrar a Verificamex Firma necesitas un segundo paso de verificación además de tu contraseña. Primero confirmaremos tu correo y luego eliges cómo recibir tus códigos.">
    <two-factor-method-setup
      mode="login"
      :token="challenge.token"
      :email-hint="challenge.email_hint"
      :remember-device="!!challenge.remember"
      @completed="onCompleted"
      @expired="onExpired"/>
  </two-factor-layout>
</template>

<script>
import { twoFactorChallenge } from '@/_helpers';
import TwoFactorLayout from './components/TwoFactorLayout';
import TwoFactorMethodSetup from './components/TwoFactorMethodSetup';

// Primer inicio de sesión con doble factor obligatorio: el usuario ya puso su contraseña
// y debe dejar configurado un método antes de entrar.
export default {
  name: 'TwoFactorSetup',
  components: { TwoFactorLayout, TwoFactorMethodSetup },
  data() {
    return {
      challenge: null
    }
  },
  created() {
    const challenge = twoFactorChallenge.get();
    if (!challenge || challenge.status !== 'SETUP') {
      this.$router.replace('/login');
      return;
    }
    this.challenge = challenge;
  },
  methods: {
    onCompleted(authResponse) {
      this.$vs.loading();
      // twoFactorComplete ya muestra su propio error si falla al cargar el perfil.
      this.$store.dispatch('account/twoFactorComplete', { authResponse, aclChangeRole: this.$acl.change })
        .catch(() => {})
        .finally(() => this.$vs.loading.close());
    },
    onExpired(message) {
      twoFactorChallenge.clear();
      this.$store.dispatch('alert/error', message);
      this.$router.replace('/login');
    }
  }
}
</script>
